import React, { Component } from "react";
import classNames from "classnames";
import skills from "./SkillsData.js";
import frontendIcon from "../../assets/eagle-emblem.png";
import backendIcon from "../../assets/hawk-emblem.png";
import "../../styles/skillsMenu.css";

export default class SkillsMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMenuItem: 1,
    };
  }

  handleMenuItemClick = (menuItem) => {
    this.setState({ activeMenuItem: menuItem });
  };

  renderContent = (skills) => {
    return skills.map((skill, index) => (
      <div
        key={index}
        className={`skill-sub-container-${this.state.activeMenuItem}`}
      >
        <h3>{skill.title}</h3>
        <div className="level-container">
          {[...Array(6)].map((_, i) => (
            <div
              key={i}
              className={`level-point ${
                i < skill.level ? "filled" : "unfilled"
              }`}
            />
          ))}
        </div>
      </div>
		));
  }

	render() {
		const { activeMenuItem } = this.state;
		const menuItems = ["Frontend", "Backend"];

		const currentIcon = activeMenuItem === 1 ? frontendIcon : backendIcon;

		return (
			<div className="skill-menu">
				{menuItems.map((menuItem, index) => (
					<div
						key={index}
						className={classNames("skill-item", {
							activeSkill: index + 1 === activeMenuItem,
						})}
						onClick={() => this.handleMenuItemClick(index + 1)}
					>
						<h2 className="skill-title">{menuItem}</h2>
					</div>
				))}
				<img src={currentIcon} className="skill-icon" alt="current skill" />
				<div className="skill-sub-container">
					{this.renderContent(skills[activeMenuItem])}
				</div>
			</div>
		)
	}
}
